import React from 'react';
import {Grid} from "@mui/material";
import styles from './Header.module.scss';

type Props = {
  children: React.ReactNode
}
export default function SecondaryHeader({children}: Props) {
  return (<>
    <Grid container item direction="row" justifyContent="space-between" className={styles['secondary-header']}>
      {children}
    </Grid>
  </>);
}
